import { render, staticRenderFns } from "./SevDeskAccountingScore.vue?vue&type=template&id=816ed480&"
import script from "./SevDeskAccountingScore.vue?vue&type=script&lang=js&"
export * from "./SevDeskAccountingScore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports